import React from 'react';
import { Route, Routes } from 'react-router-dom';
import PrivateRoute from '../../common/components/router/PrivateRoute';
import { PERMISSIONS } from '../../common/constants';
import Feedbacks from '../../features/feedbacks/Feedbacks';
import FeedbackDetails from '../../features/feedbacks/FeedbackDetails';
import NotFound from '../../common/components/router/NotFound';

const FeedbackAppRoutes = () => (
  <Routes>
    <Route
      path="/search"
      element={
        <PrivateRoute permissions={[PERMISSIONS.CustomerFeedbackRead]}>
          <Feedbacks />
        </PrivateRoute>
      }
    />
    <Route
      path="/details/:feedbackId"
      element={
        <PrivateRoute
          permissions={[
            PERMISSIONS.CustomerFeedbackRead,
            PERMISSIONS.CustomerFeedbackModify,
          ]}
        >
          <FeedbackDetails />
        </PrivateRoute>
      }
    />
    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default FeedbackAppRoutes;
